export default {
    MAP_OBJECT: 'MAP_OBJECT',
    NOTIFICATIONS: 'NOTIFICATIONS_DRAWER',
};
